import { CSSProperties } from "react";

import { useTheme, useWindowDimensions } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= 1150;
  const isMobile = width <= 600;

  const styles: Record<string, CSSProperties> = {
    container: {
      marginLeft: spacing.m,
      marginRight: spacing.m,
      padding: spacing.m,
      backgroundColor: theme.verification.banner.home.error,
      borderRadius: constants.radius.view,
      marginBottom: isMobile ? spacing.xs : spacing.m,
      width: isMobile ? 350 : undefined,
      maxWidth: isMobile ? 350 : undefined,
      justifySelf: isMobile ? "center" : undefined,
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      boxSizing: "border-box",
    },
    icon: {
      marginRight: spacing.m,
      flexShrink: 0,
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      gap: isSmallScreen ? spacing.xs : 0,
    },
    title: {
      fontWeight: 700,
    },
  };

  return styles;
};
